import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';
import MiddleSection from './MiddleSection';

const queryClient = new QueryClient();

interface CorporateLandingProps {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
}

const CorporateLanding = ({ env, initialCurrentUser, isWebview }: CorporateLandingProps) => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <HeaderSection />
        <MiddleSection />
        <FooterSection />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default CorporateLanding;
